module.exports = __webpack_public_path__ + "static/media/favicon.dfcffb82.ico";